var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2494_127693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.625 4.875H4.25C4.58152 4.875 4.89946 4.7433 5.13388 4.50888C5.3683 4.27446 5.5 3.95652 5.5 3.625C5.5 3.45924 5.56585 3.30027 5.68306 3.18306C5.80027 3.06585 5.95924 3 6.125 3H9.875C10.0408 3 10.1997 3.06585 10.3169 3.18306C10.4342 3.30027 10.5 3.45924 10.5 3.625C10.5 3.95652 10.6317 4.27446 10.8661 4.50888C11.1005 4.7433 11.4185 4.875 11.75 4.875H12.375C12.7065 4.875 13.0245 5.0067 13.2589 5.24112C13.4933 5.47554 13.625 5.79348 13.625 6.125V11.75C13.625 12.0815 13.4933 12.3995 13.2589 12.6339C13.0245 12.8683 12.7065 13 12.375 13H3.625C3.29348 13 2.97554 12.8683 2.74112 12.6339C2.5067 12.3995 2.375 12.0815 2.375 11.75V6.125C2.375 5.79348 2.5067 5.47554 2.74112 5.24112C2.97554 5.0067 3.29348 4.875 3.625 4.875Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.125 8.625C6.125 9.12228 6.32254 9.59919 6.67417 9.95083C7.02581 10.3025 7.50272 10.5 8 10.5C8.49728 10.5 8.97419 10.3025 9.32583 9.95083C9.67746 9.59919 9.875 9.12228 9.875 8.625C9.875 8.12772 9.67746 7.65081 9.32583 7.29917C8.97419 6.94754 8.49728 6.75 8 6.75C7.50272 6.75 7.02581 6.94754 6.67417 7.29917C6.32254 7.65081 6.125 8.12772 6.125 8.625Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2494_127693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.889342103e2442c115da05769a26bda7.svg";
export { ForwardRef as ReactComponent };